module.exports = __webpack_public_path__ + "img/vpay.4ddd2988.svg";